<template>
  <div>
    <div v-if="statusConfig">
      <b-tooltip multilined type="is-light" :position="position">
        <b-tag :type="statusConfig.tagType" class="is-small">
          <b-icon size="is-small" :icon="statusConfig.icon" custom-class=""></b-icon>
          &nbsp;{{ statusConfig.label }}
        </b-tag>
        <template v-slot:content>
          <h5 class="is-size-7 has-text-weight-bold has-text-left mb-1">
            {{ statusConfig.tooltipContent }}
          </h5>
        </template>
      </b-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: "FlyAmericaStatusTag",
  props: {
    status: String,
    position: {
      type: String,
      default: "is-bottom",
    },
    rule: {
      type: Object,
    }
  },
  data() {
    return {
      statusConfigurations: {
        usCompliant: {
          tagType: "is-default",
          icon: "shield-check",
          label: "Fly America",
          tooltipContent: "Fly America Compliant",
        },
        openSkiesCompliant: {
          tagType: "is-default",
          icon: "shield-check",
          label: "Fly America",
          tooltipContent: "Open Skies Compliant",
        },
        
      },
    };
  },
  computed: {
    statusConfig() {
      if (this.allowedStatuses.includes(this.status)) {
        return this.statusConfigurations[this.status];
      }
      return null;
    },
    allowedStatuses() {
      return this.ruleCondition.comparison['value'];
    },
    showFlyAmericaStatusTag() {
      return this.statusConfig !== null;
    },
    ruleCondition() {
      return this.rule.conditions.find((condition) => {
        return condition.attribute.solutionPath === "flyAmericaStatus";
      });
    }

  },
};
</script>

<style scoped></style>
